import { SwitchComponent } from './../components/forms/switch/switch.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormatPostalCodePipe } from './pipes/format-postal-code.pipe';
import { CourtesyMessagePipe } from './pipes/courtesy-message.pipe';
import { StaticPathPipe } from './pipes/static-path.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { ListingTypeAnalyticsTagPipe } from './pipes/listing-type-analytics-tag.pipe';
import { ItemSwiperComponent } from './components/item-swiper/item-swiper.component';
import { ListingAddressComponent } from './components/address/listing-address.component';
import { ListingFlagsComponent } from './components/listing-card/listing-flags/listing-flags.component';
import { ListingPriceArrowComponent } from './components/listing-price-arrow/listing-price-arrow.component';
import { RmCarouselComponent } from './components/rm-carousel/rm-carousel.component';
import { PropertyDetailsComponent } from './components/property-details/property-details.component';
import { ListingCardComponent } from './components/listing-card/listing-card.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { MapComponent } from './components/map/map.component';
import { RmSwiperDirective } from './directives/rm-swiper.directive';
import { IfPlatformDirective } from './directives/if-platform.directive';
import { ShowAuthedDirective } from './directives/show-authed.directive';
import { ImageIxImageDirective } from './directives/imgix-src.directive';
import { ImgLoaderDirective } from './directives/img-loader.directive';
import { JsonLdSchemaDirective } from './directives/json-ld-schema.directive';
import { NguiMapModule } from '@ngui/map';
import { PlainMarkerComponent } from './components/map/markers/plain-marker/plain-marker.component';
import { ListingMarkerComponent } from './components/map/markers/listing-marker/listing-marker.component';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { AccordionItemComponent } from './components/accordion/item/accordion-item.component';
import { DemographicItemComponent } from './components/demographic/demographic-item.component';
import { AdCardComponent } from './components/ad-card/ad-card.component';
import { RatingComponent } from './components/rating/rating.component';
import { CmsLinksComponent } from './components/cms-links/cms-links.component';
import { EstimatedValueComponent } from './components/estimated-value/estimated-value.component';
import { LinkCardComponent } from './components/link-card/link-card.component';
import { PoiWidgetComponent } from './components/poi-widget/poi-widget.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { EmailShareModalComponent } from './components/modals/email-share-modal/email-share-modal.component';
import { InputComponent } from '../components/forms/input/input.component';
import { RecaptchaComponent } from '../components/recaptcha/recaptcha.component';
import { OutsideClickDirective } from './directives/outsideClick.directive';
import { LoaderComponent } from '../components/loader/loader.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    RouterModule.forChild([]),
    NguiMapModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    StaticPathPipe,
    CourtesyMessagePipe,
    SafeHtmlPipe,
    ListingTypeAnalyticsTagPipe,
    FormatPostalCodePipe,
    ItemSwiperComponent,
    ListingCardComponent,
    DemographicItemComponent,
    PropertyDetailsComponent,
    RmCarouselComponent,
    ListingPriceArrowComponent,
    ListingFlagsComponent,
    ListingAddressComponent,
    MapComponent,
    PlainMarkerComponent,
    ListingMarkerComponent,
    AdCardComponent,
    BackButtonComponent,
    AccordionComponent,
    AccordionItemComponent,
    RmSwiperDirective,
    IfPlatformDirective,
    ShowAuthedDirective,
    ImageIxImageDirective,
    ImgLoaderDirective,
    JsonLdSchemaDirective,
    OutsideClickDirective,
    RatingComponent,
    CmsLinksComponent,
    EstimatedValueComponent,
    LinkCardComponent,
    PoiWidgetComponent,
    SwitchComponent,
    DropdownComponent,
    EmailShareModalComponent,
    InputComponent,
    RecaptchaComponent,
    LoaderComponent
  ],
  exports: [
    StaticPathPipe,
    CourtesyMessagePipe,
    FormatPostalCodePipe,
    SafeHtmlPipe,
    ListingTypeAnalyticsTagPipe,
    ItemSwiperComponent,
    ListingCardComponent,
    PropertyDetailsComponent,
    RmCarouselComponent,
    ListingPriceArrowComponent,
    ListingFlagsComponent,
    ListingAddressComponent,
    MapComponent,
    PlainMarkerComponent,
    ListingMarkerComponent,
    AdCardComponent,
    BackButtonComponent,
    AccordionComponent,
    AccordionItemComponent,
    DemographicItemComponent,
    RmSwiperDirective,
    IfPlatformDirective,
    ShowAuthedDirective,
    ImageIxImageDirective,
    ImgLoaderDirective,
    JsonLdSchemaDirective,
    RatingComponent,
    CmsLinksComponent,
    EstimatedValueComponent,
    LinkCardComponent,
    PoiWidgetComponent,
    SwitchComponent,
    DropdownComponent,
    EmailShareModalComponent,
    InputComponent,
    RecaptchaComponent,
    OutsideClickDirective,
    LoaderComponent
  ],
  providers: [
    StaticPathPipe,
    CourtesyMessagePipe,
    FormatPostalCodePipe,
  ]
})
export class SharedModule { }
